import React from "react";
import { connect } from "react-redux";
import { Button, Modal, Divider, Label, Grid, Form } from "semantic-ui-react";
import { toastr } from "react-redux-toastr";
import {
  getProductFields,
  setNewProduct,
  getBranchList,
} from "../../actions/DepositoryActions";
import { isPermit } from "../mainPage/permission";
import Num2persian from "num2persian";

const FORM_VALIDATION = {
  code: false,
  name: false,
  buying_price: false,
  selling_price: false,
  stock_amount: false,
  f_type: false,
  design: false,
  material: false,
  background_color: false,
  design_color: false,
  branch: false,
};

class AddProductModal extends React.Component {
  componentWillReceiveProps() {
    this.setState({ 
      code: this.props.code
    });
  }

  componentDidMount() {
    this.props.getProductFields().then(() => {
      this.setState({
        background_color_Options: this.props.productFields.background_color,
        design_color_Options: this.props.productFields.design_color,
        material_Options: this.props.productFields.material,
        design_Options: this.props.productFields.design,
        f_type_Options: this.props.productFields.f_type,
      });
    });

    this.props.getBranchList().then((response) => {
      const branchOptions = response["data"].map((branch) => ({
        key: branch.id,
        value: branch.id,
        text: branch.name,
      }));
      this.setState({ branchOptions });
    });
    this.setState({job: localStorage.getItem('type')});
  }

  state = {
    f_type: "",
    design: "",
    material: "",
    background_color: "",
    design_color: "",
    f_type_Options: {},
    design_Options: {},
    material_Options: {},
    background_color_Options: {},
    design_color_Options: {},
    formValidation: FORM_VALIDATION,
    code: "",
    name: "",
    buying_price: "",
    selling_price: "",
    buying_price_persianLetter: "",
    selling_price_persianLetter: "",
    stock_amount: "",
    branch: null,
    branchOptions: [],
    job: ""
  };

  inputChange = (event, inputName) => {
    this.setState(
      {
        [inputName]: event.target.value,
      },
      () => {
        if (inputName === "buying_price" || inputName === "selling_price") {
          this.setState({
            [inputName + "_persianLetter"]: Num2persian(
              Number(this.state[inputName])
            ),
          });
        }
      }
    );
  };

  selectChange = (e, { name, value }) => {
    if (name && value !== undefined) {
      this.setState({
        [name]: value,
      });
    }
  };

  formSubmitHandler = () => {
    this.setState(
      { formValidation: { ...this.state.formValidation, ...FORM_VALIDATION } },
      () => {
        let hasError = false;
        if (String(this.state.code).length < 1) {
          this.setState({
            formValidation: { ...this.state.formValidation, code: true },
          });
          hasError = true;
        }
        if (String(this.state.name).length < 1) {
          this.setState({
            formValidation: { ...this.state.formValidation, name: true },
          });
          hasError = true;
        }
        if (String(this.state.buying_price).length < 1) {
          this.setState({
            formValidation: {
              ...this.state.formValidation,
              buying_price: true,
            },
          });
          hasError = true;
        }
        if (String(this.state.selling_price).length < 1) {
          this.setState({
            formValidation: {
              ...this.state.formValidation,
              selling_price: true,
            },
          });
          hasError = true;
        }
        if (String(this.state.stock_amount).length < 1) {
          this.setState({
            formValidation: {
              ...this.state.formValidation,
              stock_amount: true,
            },
          });
          hasError = true;
        }
        if (String(this.state.background_color).length < 1) {
          this.setState({
            formValidation: {
              ...this.state.formValidation,
              background_color: true,
            },
          });
          hasError = true;
        }
        if (String(this.state.design_color).length < 1) {
          this.setState({
            formValidation: {
              ...this.state.formValidation,
              design_color: true,
            },
          });
          hasError = true;
        }
        if (String(this.state.branch).length < 1) {
          this.setState({
            formValidation: {
              ...this.state.formValidation,
              branch: true,
            },
          });
          hasError = true;
        }
        if (String(this.state.material).length < 1) {
          this.setState({
            formValidation: { ...this.state.formValidation, material: true },
          });
          hasError = true;
        }
        if (String(this.state.f_type).length < 1) {
          this.setState({
            formValidation: { ...this.state.formValidation, f_type: true },
          });
          hasError = true;
        }
        if (String(this.state.design).length < 1) {
          this.setState({
            formValidation: { ...this.state.formValidation, design: true },
          });
          hasError = true;
        }
        if (!hasError) {
          const prepareData = {
            code: this.state.code,
            name: this.state.name,
            buying_price: this.state.buying_price,
            selling_price: this.state.selling_price,
            stock_amount: this.state.stock_amount,
            branch: this.state.branch,
            background_color: this.state.background_color,
            f_type: this.state.f_type,
            design_color: this.state.design_color,
            design: this.state.design,
            material: this.state.material,
          };
          this.props.setNewProduct(prepareData).then(() => {
            this.props.onClose();
            this.setState({
              code: "",
              buying_price: "",
              selling_price: "",
            });
            toastr.success("ثبت محصول جدید", "محصول جدید با موفقیت ثبت شد");
          });
        }
      }
    );
  };

  render() {
    return (
      <div>
        <Modal
          id="add-bill"
          closeOnDimmerClick={false}
          dimmer="blurring"
          className="text-right rtl yekan"
          open={this.props.open}
          onClose={this.props.onClose}
        >
          <Modal.Header className="yekan">ثبت محصول جدید</Modal.Header>
          <Modal.Content scrolling>
            <Modal.Description>
              <Form>
                <Form.Group widths={3}>
                  <Form.Select
                    fluid
                    placeholder="رنگ پس زمینه"
                    label="رنگ پس زمینه"
                    search
                    selection
                    error={this.state.formValidation.background_color}
                    onChange={this.selectChange}
                    name="background_color"
                    options={this.state.background_color_Options}
                  />
                  <Form.Select
                    fluid
                    placeholder="رنگ طرح"
                    label="رنگ طرح"
                    search
                    selection
                    error={this.state.formValidation.design_color}
                    onChange={this.selectChange}
                    name="design_color"
                    options={this.state.design_color_Options}
                  />
                  <Form.Select
                    fluid
                    placeholder="جنس"
                    label="جنس"
                    search
                    selection
                    error={this.state.formValidation.material}
                    onChange={this.selectChange}
                    name="material"
                    options={this.state.material_Options}
                  />
                </Form.Group>
                <Form.Group widths={3}>
                  <Form.Select
                    fluid
                    placeholder="نوع پارچه"
                    label="نوع پارچه"
                    search
                    selection
                    error={this.state.formValidation.f_type}
                    onChange={this.selectChange}
                    name="f_type"
                    options={this.state.f_type_Options}
                  />
                  <Form.Select
                    fluid
                    placeholder="نوع طرح"
                    label="نوع طرح"
                    search
                    selection
                    error={this.state.formValidation.design}
                    onChange={this.selectChange}
                    name="design"
                    options={this.state.design_Options}
                  />
                </Form.Group>
                <Divider />
                <Form.Group unstackable widths={2}>
                  <Form.Input
                    className="ltr placeholder-rtl"
                    label="کد محصول"
                    defaultValue={this.props.code}
                    type="number"
                    error={this.state.formValidation.code}
                    onChange={(e) => this.inputChange(e, "code")}
                    placeholder="کد محصول"
                  />
                  <Form.Input
                    className="ltr placeholder-rtl"
                    label="نام محصول"
                    error={this.state.formValidation.name}
                    onChange={(e) => this.inputChange(e, "name")}
                    placeholder="نام محصول"
                  />
                </Form.Group>
                <Form.Group unstackable widths={2}>
                  <Form.Input
                    className="ltr placeholder-rtl"
                    label="مقدار باقی مانده"
                    type="number"
                    error={this.state.formValidation.stock_amount}
                    onChange={(e) => this.inputChange(e, "stock_amount")}
                    placeholder="مقدار باقی مانده"
                  />
                  {isPermit("new_branch_enabled_section", this.state.job) && (
                    <Form.Select
                      fluid
                      placeholder="شعبه"
                      label="شعبه"
                      search
                      selection
                      onChange={this.selectChange}
                      name="branch"
                      options={this.state.branchOptions}
                    />
                  )}
                </Form.Group>
                <Form.Group unstackable widths={2}>
                  <Form.Input
                    className="ltr placeholder-rtl"
                    label="قیمت فروش"
                    type="number"
                    error={this.state.formValidation.selling_price}
                    onChange={(e) => this.inputChange(e, "selling_price")}
                    placeholder="قیمت فروش"
                  />
                  <Form.Input
                    className="ltr placeholder-rtl"
                    label="قیمت خرید"
                    type="number"
                    error={this.state.formValidation.buying_price}
                    onChange={(e) => this.inputChange(e, "buying_price")}
                    placeholder="قیمت خرید"
                  />
                </Form.Group>
                <Grid className="rtl">
                  <Grid.Column>
                    <Label ribbon className="text-right yekan">
                      {this.state.buying_price_persianLetter &&
                        " قیمت خرید: " + this.state.buying_price_persianLetter}
                    </Label>
                    <Label ribbon className="text-right yekan">
                      {this.state.selling_price_persianLetter &&
                        " قیمت فروش: " + this.state.selling_price_persianLetter}
                    </Label>
                  </Grid.Column>
                </Grid>
              </Form>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="black"
              onClick={() => {
                this.props.onClose();
                this.setState({
                  code: "",
                  buying_price: "",
                  selling_price: "",
                });
              }}
            >
              لغو
            </Button>
            <Button
              positive
              icon="checkmark"
              labelPosition="right"
              content="ثبت"
              onClick={this.formSubmitHandler}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  productFields: state.depository.productFields,
  branches: state.depository.branches,
});

export default connect(mapStateToProps, {
  getProductFields,
  setNewProduct,
  getBranchList,
})(AddProductModal);
